module.exports = __webpack_public_path__ + "static/blue1-4bb62b185cd9be8f5d9ff838f4918985.png";